// @router
import { RouteConfig } from 'vue-router'

export const fileManagementRoutes: RouteConfig[] = [];
